import "./device-login.scss";
import { Button } from '../../button/button';

import { loginPhrases } from '../../../../types/login';
import { modalTypeEnum } from '../../../../types/modal';

import React, { FunctionComponent, useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../features';
import { getIsNpos, getIsRegisterStatus, setModalSignInUp, wipeLocalStorage } from '../../../../store/AppSlice';
import { getSpanErrorMessage, setNotificationButtonLoad } from '../../../../store/NotificationSlice';
import { decryptionProcess, encryptionProcess, setLocalPassword } from '../../../../store/EncryptionSlice';
import { requestNposSettings, requestUserSettings } from "../../../../store/UserSlice";

export const ModalDeviceLogin: FunctionComponent = () => {
    
    const dispatch                              = useAppDispatch();

    const [pass, setPass]                       = useState<string>('');
    const [showErrorSpan, setShowErrorSpan]     = useState(false);
    const [isLoadingLocal, setIsLoadingLocal]   = useState(false);
    const isNpos: boolean                       = useAppSelector(getIsNpos);

    const phrases                               = loginPhrases;
    const isRegistered                          = useAppSelector(getIsRegisterStatus);
    const spanErrorMessage                      = useAppSelector(getSpanErrorMessage);

    const cat = isRegistered ? 'notRegister' : 'isRegister';

    const handleLoginClick = async () => {
        
        setIsLoadingLocal(true);
        dispatch(setNotificationButtonLoad(true));
        dispatch(setLocalPassword(pass));

        try {
            if (isRegistered) {

                const encryptionSuccess = await dispatch(encryptionProcess());
                if (encryptionSuccess) {

                    try {
                        await dispatch(decryptionProcess());
                    } catch (err) {
                        console.error(`not decryptions for you `, err);
                    }
                }
        
            } else {
                await dispatch(decryptionProcess());
            }

            try {
                if (isNpos) {
                    await dispatch(requestNposSettings())
                } else {
                    await dispatch(requestUserSettings())
                }
            } catch (err) {
                console.error(`not user setting for you `, err);    
            }
            
        } catch (err) {
            console.error(`not encryptions for you `, err);
        } finally {
            setIsLoadingLocal(false);
            buttonDottedTimer();
        }
    }

    const handleLogoutClick = () => {
        setIsLoadingLocal(true);
        dispatch( wipeLocalStorage() );
        setIsLoadingLocal(false);
        dispatch( setModalSignInUp(modalTypeEnum.register));
    }
    
    const buttonDottedTimer = () => {
        setTimeout( () => {
            dispatch(setNotificationButtonLoad(false));
        }, 2000)
    }

    const handlePasswordChange = (pass:string) => {
        setPass(pass);
        setShowErrorSpan(false);
    }

    const handleEnterClick = (e:React.KeyboardEvent<HTMLInputElement>) => {
        if (e.type !== 'keydown') return false;
        if (e.key === 'Enter') handleLoginClick();
    } 

    useEffect(() => {
        if (spanErrorMessage !== "") setShowErrorSpan(true);
    }, [spanErrorMessage])

    return (
        <div className="modal-login modal-device">
            <div className="modal">
                <div className="form">
                    <legend>
                        <h1>
                            {phrases[cat].title}
                            <br />
                            <small>
                                {phrases[cat].helper}
                            </small>
                            <small>
                                {phrases[cat].small}
                            </small>
                        </h1>
                    </legend>
                    <fieldset>
                        <div className="form-input-wrapper">
                            <label htmlFor=""></label>
                            <input type="password" maxLength={6}
                                className='bottomPad'
                                onChange={e => handlePasswordChange(e.target.value)} onKeyDown={handleEnterClick}/>
                        </div>
                        {showErrorSpan && <span>{spanErrorMessage}</span>}
                        <div>
                            <h2>Dicas:</h2>
                            <ul>
                                <li>Senha alfanumerica - (números e letras)</li>
                                <li>6 caracteres de tamanho</li>
                            </ul>
                        </div>
                        <Button 
                            label={phrases.button[cat]} 
                            onClick={() => handleLoginClick()} 
                            disabled={isLoadingLocal}
                            type="unlock"  />
                        <Button 
                            label="Logout"
                            onClick={() => handleLogoutClick()} 
                            disabled={isLoadingLocal} 
                            type="logout" />
                    </fieldset>
                </div>
            </div>
        </div>
    )
}